angular
  .module('deskfy.arts')
  .controller('UserArtsSearchController', UserArtsSearchController)

/* @ngInject */
function UserArtsSearchController ($scope, $rootScope, $state, $timeout, $translate, $q, ArtsService, ArtCollectionsService, ToastService, SelectMaterialCollectionService) {
  $scope.getSearchTotalCount = () => ($scope.search.collections?.totalCount || 0) + ($scope.search.templates?.totalCount || 0)
  $scope.getSearchResultCount = () => ($scope.search.collections?.results?.length || 0) + ($scope.search.templates?.results?.length || 0)
  $scope.canShowFooter = () => $scope.search.state.loading || ($scope.getSearchTotalCount() > $scope.getSearchResultCount())

  $scope.selectedTemplates = []
  $scope.selectedCollections = []

  $scope.disabledTemplatesRule = null
  $scope.floatingBarLocation = 'userArts'

  const api = {
    _initSearch,
    _handleResetSearch,
    _loadResults,
    _loadBreadcrumbs,
    _loadResultsWithQuery,
    _loadResultsWithoutQuery,
    _loadMoreCollections,
    _loadMoreTemplates,
    _handleKeyboardNavigation,
    _handleNavigateThroughKeyboard,
    _defineDisabledTemplatesRule
  }
  this.getApi = () => api

  activate()
  function activate () {
    api._handleKeyboardNavigation()
  }

  const deregisterSearchWatcher = $scope.$watch('search.filters', (newValue, oldValue) => {
    if (JSON.stringify(newValue) === JSON.stringify(oldValue)) return
    api._loadBreadcrumbs()
    api._initSearch()
  }, true)

  $scope.$on('$destroy', () => {
    deregisterSearchWatcher()
    document.removeEventListener('keydown', api._handleNavigateThroughKeyboard)
  })

  $scope.handleLoadMoreItems = function () {
    api._loadResults()
  }

  function _initSearch () {
    if (!$scope.search.state.searching) {
      $scope.search.state.loading = false
      return
    }

    $scope.search.state.loading = true
    $scope.search.templates.results = []
    $scope.search.templates.totalCount = 0
    $scope.search.templates.pagination.skip = 0
    $scope.search.templates.pagination.top = 8
    $scope.search.templates.pagination.loading = false
    $scope.search.collections.results = []
    $scope.search.collections.totalCount = 0
    $scope.search.collections.pagination.skip = 0
    $scope.search.collections.pagination.top = 8
    $scope.search.collections.pagination.loading = false

    api._loadResults()
  }

  function _loadResults () {
    $scope.search?.filters?.query ? api._loadResultsWithQuery() : api._loadResultsWithoutQuery()
  }

  function _loadResultsWithQuery () {
    $scope.search.state.loading = true
    const search = $scope.search
    const searchParams = {
      formatId: search?.filters?.formatIds,
      artTagIds: search?.filters?.tagIds,
      campaignId: search?.filters?.campaignId,
      needApproval: search?.filters?.needApproval,
      customizationLevel: search?.filters?.customizationLevel
    }

    const templatesTop = 8
    const templatesSkip = 0

    const collectionsTop = 8
    const collectionsSkip = 0
    const shouldSkipCollections = searchParams.customizationLevel || searchParams.formatId || searchParams.needApproval || searchParams.artTagIds

    const templatePromise = ArtsService.search(search.filters?.query, templatesTop, templatesSkip, searchParams)
    const collectionPromise = shouldSkipCollections
      ? Promise.resolve({ rows: [], count: 0 })
      : ArtCollectionsService.searchArtCollections(search.filters?.query, collectionsTop, collectionsSkip, false, false)

    $q.all([templatePromise, collectionPromise]).then(([templates, collections]) => {
      const safeTemplates = templates || { rows: [], count: 0 }
      const safeCollections = collections || { rows: [], count: 0 }

      $scope.search.templates = {
        results: [...(search.templates?.results ?? []), ...(safeTemplates?.rows ?? [])],
        pagination: {
          ...search.templates?.pagination,
          skip: templatesSkip + (safeTemplates?.rows?.length ?? 0)
        },
        totalCount: safeTemplates.count
      }

      $scope.search.collections = {
        results: [...(search.collections?.results ?? []), ...(safeCollections?.rows ?? [])],
        pagination: {
          ...search.collections?.pagination,
          skip: collectionsSkip + (safeCollections?.rows?.length ?? 0)
        },
        totalCount: safeCollections.count
      }
    })
      .catch(error => {
        console.error({ error })
        ToastService.showErrorToast($translate.instant('userArts.arts.error'))
      })
      .finally(() => { $scope.search.state.loading = false })
  }

  $scope.loadMoreCollections = function () {
    api._loadMoreCollections()
  }

  $scope.loadMoreTemplates = function () {
    api._loadMoreTemplates()
  }

  function _loadMoreTemplates () {
    const search = $scope.search
    const pagination = search.templates.pagination
    pagination.loading = true
    const searchParams = {
      formatId: search?.filters?.formatIds,
      artTagIds: search?.filters?.tagIds,
      campaignId: search?.filters?.campaignId,
      needApproval: search?.filters?.needApproval,
      customizationLevel: search?.filters?.customizationLevel
    }

    ArtsService.search(search.filters?.query, pagination.top, pagination.skip, searchParams)
      .then(response => {
        $scope.search.templates = {
          ...search.templates,
          results: [...(search.templates?.results ?? []), ...(response?.rows ?? [])],
          pagination: {
            ...pagination,
            skip: pagination.skip + (response?.rows?.length ?? 0),
            loading: false
          }
        }
      })
  }

  function _loadMoreCollections () {
    const search = $scope.search
    const pagination = search.collections.pagination
    pagination.loading = true

    ArtCollectionsService.searchArtCollections(search.filters?.query, pagination.top, pagination.skip, false, false)
      .then(response => {
        $scope.search.collections = {
          ...search.collections,
          results: [...(search.collections?.results ?? []), ...(response?.rows ?? [])],
          pagination: {
            ...pagination,
            skip: pagination.skip + (response?.rows?.length ?? 0),
            loading: false
          }
        }
      })
  }

  function _loadResultsWithoutQuery () {
    $scope.search.state.loading = true
    const search = $scope.search
    const templatesTop = 8
    const templatesSkip = 0

    const searchParams = {
      formatId: search?.filters?.formatIds,
      artTagIds: search?.filters?.tagIds,
      campaignId: search?.filters?.campaignId,
      needApproval: search?.filters?.needApproval,
      customizationLevel: search?.filters?.customizationLevel
    }

    ArtsService.search(search.filters?.query, templatesTop, templatesSkip, searchParams)
      .then(response => {
        $scope.search.templates = {
          results: [...(search.templates?.results ?? []), ...(response?.rows ?? [])],
          pagination: {
            ...search.templates?.pagination,
            skip: templatesSkip + (response?.rows?.length ?? 0)
          },
          totalCount: response.count
        }
      })
      .catch(error => {
        console.error({ error })
        ToastService.showErrorToast($translate.instant('userArts.arts.error'))
      })
      .finally(() => { $scope.search.state.loading = false })
  }

  function _loadBreadcrumbs () {
    if (!$scope.search?.state?.searching) {
      $scope.$parent.breadcrumbs = {
        items: []
      }
      return
    }

    const root = {
      id: 'user.arts',
      value: 'user.arts',
      label: $translate.instant('userArts.arts.title')
    }
    const current = {
      id: 'user.arts.search',
      label: $translate.instant('userArts.arts.search.title')
    }

    $scope.$parent.breadcrumbs = {
      items: [root, current],
      onChange: (event) => {
        if (!event.value) return
        api._handleResetSearch()
        $state.go(event.value)
      }
    }
  }

  function _handleResetSearch () {
    $timeout(() => {
      $rootScope.$broadcast('user-search-bar.reset')
      const parentSearch = $scope.$parent.search

      $scope.$parent.breadcrumbs.items = []
      $scope.$parent.search = {
        ...parentSearch,
        state: {
          ...parentSearch.state,
          loading: false,
          searching: false
        },
        templates: {
          ...parentSearch.templates,
          results: [],
          pagination: {
            ...parentSearch.templates.pagination,
            skip: 0
          }
        },
        collections: {
          ...parentSearch.collections,
          results: [],
          pagination: {
            ...parentSearch.collections.pagination,
            skip: 0
          }
        }
      }
    }, 100)
  }

  $scope.onCollectionCardClick = function (collection, event) {
    const isShiftPressed = event && event.shiftKey

    if (collection.selected) {
      collection.firstSelection = false
      collection.selected = false
      $scope.selectedCollections = $scope.selectedCollections.filter(c => c.id !== collection.id)
    } else {
      if ($scope.selectedCollections.length === 0 && $scope.selectedTemplates.length === 0) {
        collection.firstSelection = true
      }

      if (isShiftPressed) {
        const { selectedCollections, selectedTemplates } = SelectMaterialCollectionService.handleShiftClickOnCollection(collection, {
          selectedTemplates: $scope.selectedTemplates,
          selectedCollections: $scope.selectedCollections,
          section: $scope.search,
          disabledTemplatesRule: $scope.disabledTemplatesRule
        })

        $scope.selectedCollections = selectedCollections
        $scope.selectedTemplates = selectedTemplates
        return
      }

      collection.selected = true
      $scope.selectedCollections.push(collection)
    }
  }

  $scope.handleTemplateClick = function (template, event) {
    const isShiftPressed = event && event.shiftKey

    if (template.selected) {
      template.selected = false
      $scope.selectedTemplates = $scope.selectedTemplates.filter(t => t.id !== template.id)
    } else {
      if ($scope.selectedTemplates.length === 0) {
        template.firstSelection = true
      }

      if (isShiftPressed) {
        const { selectedCollections, selectedTemplates } = SelectMaterialCollectionService.handleShiftClickOnMaterial(template, {
          selectedTemplates: $scope.selectedTemplates,
          selectedCollections: $scope.selectedCollections,
          collection: $scope.search,
          disabledTemplatesRule: $scope.disabledTemplatesRule
        })

        $scope.selectedCollections = selectedCollections
        $scope.selectedTemplates = selectedTemplates

        api._defineDisabledTemplatesRule()
        return
      }

      template.selected = true
      if (!$scope.selectedTemplates.some(t => t.id === template.id)) {
        $scope.selectedTemplates.push(template)
      }
    }

    api._defineDisabledTemplatesRule()
  }

  $scope.isTemplateDisabled = function (template) {
    if ($scope.disabledTemplatesRule === 'ALL' && $scope.selectedTemplates.length) {
      return template.id !== $scope.selectedTemplates[0].id
    } else if ($scope.disabledTemplatesRule === 'CUSTOMIZABLE') {
      return template.isCustomizable && template.customizationLevel !== 'ONLY_DOWNLOAD'
    }

    return false
  }

  function _handleKeyboardNavigation () {
    document.addEventListener('keydown', api._handleNavigateThroughKeyboard)
  }

  function _handleNavigateThroughKeyboard (ev) {
    if ((!$scope.selectedTemplates.length && !$scope.selectedCollections.length)) {
      return
    }

    SelectMaterialCollectionService.handleNavigateThroughKeyboard(ev, {
      selectedTemplates: $scope.selectedTemplates,
      selectedCollections: $scope.selectedCollections,
      collection: $scope.search,
      scope: $scope,
      disabledTemplatesRule: $scope.disabledTemplatesRule
    })

    api._defineDisabledTemplatesRule()
  }

  function _defineDisabledTemplatesRule () {
    $scope.disabledTemplatesRule = SelectMaterialCollectionService.getDisabledTemplatesRule($scope.selectedTemplates)
    if (!$scope.$$phase) {
      $scope.$apply()
    }
  }
}

export { UserArtsSearchController }
